import type { NextApiRequest, NextApiResponse } from 'next'
import {
  type CreateUpdateOrderDTO,
  type Language,
  type PostNordUpdateSessionRequestFE,
  type PostNordUpdateSessionResponseFE
} from 'ecosystem'
import {
  createError,
  transformOrderItemsToCreateOrderItems,
  useLocaleCredentials as setLocaleCredentials
} from 'api'
import storefrontApi from 'api/storefront-api'
import { handlerWithLogging } from '../../../logging'

export const postnordUpdateSessionHandler = handlerWithLogging(
  async (
    req: NextApiRequest,
    res: NextApiResponse<PostNordUpdateSessionResponseFE | { error: string }>
  ) => {
    const locale = (req.cookies.NEXT_LOCALE as Language) || 'sv'
    setLocaleCredentials(locale)

    if (req.method !== 'POST') {
      res.status(405).json({ error: 'Method not supported.' })
      return
    }

    const { sessionId, ...postnordDetails } = req.body as PostNordUpdateSessionRequestFE

    try {
      const { data: order, error } = await storefrontApi.orders.getStorefrontOrder({
        orderNumber: sessionId
      })

      if (error || !order) {
        throw createError(error || 'Get postnord information error')
      }

      const newOrder: CreateUpdateOrderDTO = {
        ...order,
        customer: null,
        items: transformOrderItemsToCreateOrderItems(order.items ?? []),
        shippingInfo: {
          ...order.shippingInfo,
          additionalInfo: {
            ...order.shippingInfo?.additionalInfo,
            postnordDetails: {
              ...order.shippingInfo?.additionalInfo?.postnordDetails,
              ...postnordDetails
            }
          }
        }
      }

      await storefrontApi.orders.updateStorefrontOrder(newOrder)

      res.status(200).json({ success: true } as PostNordUpdateSessionResponseFE)
    } catch (e) {
      const responseError = e instanceof Error ? e.message : 'unknown'

      res.status(400).json({ error: responseError })
    }
  }
)
